export const KPI_NUMBER_OF_DAILY_HOURS = 12;
export const KPI_ATTACHMENTS_COLLECTION_NAME = 'workpack';
/** Collection name for log entry attachments (used in MediaViewer/FileDisplay) */
export const KPI_LOG_ENTRY_ATTACHMENTS_COLLECTION_NAME = 'logEntry';
export const KPI_NOTE_LOG_METADATA_KEY = 'kpiLogDate';
export const KPI_NOTE_LOG_SHIFT_METADATA_KEY = 'kpiLogShift';
export const KPI_POB_FIELD_KEY = 'pob' as const;
export const KPI_CONFIG_SECTION_KEY = 'config';

/** Comment metadata type: log-scoped notes (section/discrepancy) shown in Log details and History only */
export const COMMENT_METADATA_TYPE_KPI_LOG_NOTE = 'KPI_LOG_NOTE';
/** Comment metadata type: general workpack comments shown in Comments section */
export const COMMENT_METADATA_TYPE_WORKPACK_COMMENT = 'WORKPACK_COMMENT';
/** Comment key for QA/QC job phase remarks (per log entry, date, shift) */
export const QAQC_JOB_PHASE_REMARKS_COMMENT_KEY = 'qaqc.job_phase_remarks';
/** Comment metadata type: QA/QC job phase remarks tied to a log entry */
export const COMMENT_METADATA_TYPE_QAQC_JOB_PHASE_REMARKS = 'QAQC_JOB_PHASE_REMARKS';

export const REMARKS_PLACEHOLDER =
  'Enter remarks relevant to this job phase for audit and record-keeping purposes.';

export const COLUMN_SETTINGS_HEADING = 'Column Settings';
export const COLUMN_SETTINGS_SUB_HEADING =
  'Select the columns you want to display in the table, then rearrange them to set the order.';
